import api from './ApiService';
import qs from 'query-string';

export async function getAllCities(query) {
  const { data } = await api.get(`cities-all?${qs.stringify(query)}`);
  return data;
}
